var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2"},[(_vm.showManagingEntities)?_c('EntitiesDialog',{key:_vm.dialogKey,attrs:{"show-right-dialog-entity":_vm.showManagingEntities}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }